// extracted by mini-css-extract-plugin
module.exports = {"panels":"help-and-support_panels__u3_l2","title":"help-and-support_title__Hn5L1","faqWrapper":"help-and-support_faqWrapper__rFQgu"};